import { UrlMetadataResponse } from '@/interfaces/responses/url-metadata';

export const ObjectHelper = {
	getId(urlMetadata: UrlMetadataResponse) {
		return urlMetadata.parent_object_id ? urlMetadata.parent_object_id : urlMetadata.object_id;
	},

	getType(urlMetadata: UrlMetadataResponse) {
		return urlMetadata.parent_object_type ? urlMetadata.parent_object_type : urlMetadata.object_type;
	},

	shallowDifference(obj1: any, obj2: any) {
		return !obj1 || !obj2 || JSON.stringify(obj1) !== JSON.stringify(obj2);
	},

	arrayOfStringsAreEquals(arry1: string[] = [], arr2: string[] = []) {
		return JSON.stringify([...arry1].sort()) === JSON.stringify([...arr2].sort());
	},

	arraysAreEquals(arry1: any[] = [], arr2: any[] = []) {
		return JSON.stringify([...arry1].sort()) === JSON.stringify([...arr2].sort());
	},

	cloneDeep<O>(object: O): O {
		return JSON.parse(JSON.stringify(object));
	},

	/**
	 * Object.keys with types
	 */
	keys<O>(object: O): (keyof O)[] {
		return Object.keys(object) as (keyof O)[];
	},

	/**
	 * Object.fromEntries with types
	 */
	fromEntries<KEY extends string, VALUE>(values: [KEY, VALUE][]): Record<KEY, VALUE> {
		return Object.fromEntries(values) as Record<KEY, VALUE>;
	},

	shuffleArray<T>(array: T[]) {
		const arrayToShuffle = [...array];

		for (let i = arrayToShuffle.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			[arrayToShuffle[i], arrayToShuffle[j]] = [arrayToShuffle[j], arrayToShuffle[i]];
		}

		return arrayToShuffle;
	},

	// helper function similar to underscore’s pluck
	pluck<T>(values: T[], by: keyof T) {
		return values.reduce((previousValue, currentValue) => {
			const key: keyof T = (currentValue[by] as unknown) as keyof T;
			previousValue[key] = currentValue;
			return previousValue;
		}, {} as Record<keyof T, T>);
	},
};
